import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCities,
  fetchStates,
} from "../../../components/entities/address/addressesSlice";
import { setEmployeeData } from "./employeeSlice";
function validNumber(x) {
  const out = /^(?!\s*$)[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$/.test(x || "");
  return out;
}
const useEmployeeAddress = () => {
  const dispatch = useDispatch();

  const { activeIndex, address, statesarray, cityarray, nextBtnEnable } =
    useSelector((state) => state.employeeregister);

  useEffect(() => {
    handleEnableNext();
  }, [activeIndex, address]);

  const handleEnableNext = () => {
    if (activeIndex === 1) {
      if (
        address?.country?.code &&
        address?.address_line_1 &&
        address?.postalcode &&
        validNumber(address?.postalcode)
      ) {
        dispatch(
          setEmployeeData({
            key: "nextBtnEnable",
            value: true,
          }),
        );
      } else {
        dispatch(
          setEmployeeData({
            key: "nextBtnEnable",
            value: false,
          }),
        );
      }
    }
  };

  useEffect(() => {
    handleStateOption();
  }, [address?.country]);

  useEffect(() => {
    handleCitiesOptions();
  }, [address?.state]);

  const handleStateOption = () => {
    const countryCode = address?.country?.code;
    if (countryCode) {
      dispatch(fetchStates(countryCode)).then((response) => {
        const options = response.payload.map((state) => ({
          name: state.label,
          code: state.value,
        }));
        dispatch(setEmployeeData({ key: "statesarray", value: options }));
        dispatch(
          setEmployeeData({
            key: "address",
            value: { ...address, state: "", city: "" },
          }),
        );
      });
    }
  };

  const handleCitiesOptions = () => {
    const countryCode = address?.country?.code;
    const stateCode = address?.state?.code;
    if (stateCode && countryCode) {
      dispatch(fetchCities([countryCode, stateCode])).then((response) => {
        const cityOptions = response.payload.map((city) => ({
          name: city.label,
          code: city.value,
        }));
        dispatch(setEmployeeData({ key: "cityarray", value: cityOptions }));
        dispatch(
          setEmployeeData({
            key: "address",
            value: { ...address, city: "" },
          }),
        );
      });
    }
  };

  const onChangeAddress = (name, value) => {
    dispatch(
      setEmployeeData({
        key: "address",
        value: { ...address, [name]: value },
      }),
    );
  };

  return {
    onChangeAddress,
    address,
    statesarray,
    cityarray,
  };
};

export default useEmployeeAddress;
